import {h, Fragment} from "preact"
import { usePagination, useActions } from "@nosto/preact"
import Icon from "./elements/Icon"

function PageLink({ onClick, href, className, ariaLabel, children }) {
    return (
        <a
            class={`ns-page-link ns-d-block ns-relative ns-text-undecorated ns-clickable ns-border-radius-3 ${className}`}
            href={href}
            aria-label={ariaLabel}
            onClick={onClick}
        >
            {children}
        </a>
    )
}

export default function Pagination() {
    const { prev, first, pages, last, next } = usePagination({
        width: 5
    })

    const { updateSearch, simulateUpdateSearch } = useActions()

    function pageLinkProps({ from }) {
        return {
            onClick: e => {
                e.preventDefault()
                updateSearch({ products: { from } })
                scrollTo(0, 0)
            },
            href: simulateUpdateSearch({ products: { from } }).url
        }
    }

    return (
        <div class="ns-d-flex ns-justify-content-center ns-align-items-center ns-pagination">
            {prev && (
                <span class="ns-page-arrow">
                    <PageLink {...pageLinkProps(prev)} className="ns-previous" ariaLabel="Previous page">
                        <svg width="14px" height="14px" fill="black" aria-hidden="true" focusable="false" data-icon="arrow-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                            <path fill="currentColor" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"></path>
                        </svg>
                    </PageLink>
                </span>
            )}
            <ul class="ns-d-flex ns-flex-wrap ns-list-unstyled ns-m-0 ns-p-0 ns-mx-0 ns-pagination-inner">
                {first && (
                    <>
                        <li>
                            <PageLink {...pageLinkProps(first)} ariaLabel="First page">
                                {first.page}
                            </PageLink>
                        </li>
                        <li><span class="ns-d-block ns-py-2 ns-px-4">...</span></li>
                    </>
                )}

                {pages.map(page => (
                    <li key={page.page} class={`${page.current ? "ns-active ns-color-black" : ""}`}>
                        <PageLink ariaLabel={`${page.page} page`} {...pageLinkProps(page)}>{page.page}</PageLink>
                    </li>
                ))}

                {last && (
                    <>
                        <li><span class="ns-py-2 ns-px-4">...</span></li>
                        <li>
                            <PageLink {...pageLinkProps(last)} ariaLabel="Last page">{last.page}</PageLink>
                        </li>
                    </>
                )}
            </ul>
            {next && (
                <span class="ns-page-arrow">
                    <PageLink {...pageLinkProps(next)} className="ns-next" ariaLabel="Next page">
                        <svg width="14px" height="14px" fill="black" aria-hidden="true" focusable="false" data-icon="arrow-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                            <path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path>
                        </svg>
                    </PageLink>
                </span>
            )}
        </div>
    )
}
